import styled from 'styled-components';

export const MainImageStyles = styled.section<{
  backgroundSrc: string;
}>`
  body.dark & {
  }

  padding: 20px 0;
  position: relative;
  background: url(${(props) => props.backgroundSrc});
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 540px auto;
  max-width: 540px;
  margin: 0 auto;
  min-height: 880px;
`;

export const BulbeContainer = styled.div`
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 238px;
  height: 166px;
  z-index: 1;
`;

export const BulbeBackground = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const BulbeText = styled.p`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #ffffff;
  padding: 24px 12px 0;
`;

export const MainImageContentStyles = styled.div`
  z-index: 1;
  position: absolute;
  bottom: -120px;
  left: 50%;
  transform: translate(-50%, -10px);
  width: 100%;

  .main-image-title {
    margin: 0 0 8px;
    font-size: 24px;
    line-height: 40px;
  }
`;
